import React, { Component } from 'react';
import { CheckIcon, GlobeIcon, LockIcon, ShieldIcon, ZapIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
const included = ['Module 1 — Dance Fitness Foundations™', 'Module 2 — Ready-to-Teach Class Structures™', 'Module 3 — Choreography Library™', 'Module 4 — Dance Cardio System™', 'Module 5 — Themed Classes™', 'Module 6 — Instructor Success™', 'Module 7 — Annual Planning System™', '100 Ready-to-Use Class Ideas™ — FREE', '50 Complete Class Plans™ — FREE', '365 Warm-Ups, Cool-Downs & Combinations™ — FREE', 'Monthly Dance Fitness Challenges™ — FREE', 'Professional Planner & Business Toolkit™ — FREE'];
export function PricingSection() {
  return <section id="pricing" className="bg-navy px-4 py-20 text-white" data-id="element-166">
      <div className="mx-auto max-w-3xl" data-id="element-167">
        <header className="mb-9 text-center" data-id="element-168">
          <p className="text-xs font-bold uppercase tracking-[.18em] text-orange" data-id="element-169">
            Special launch offer
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold sm:text-5xl" data-id="element-170">
            Your complete 7-in-1 system
          </h2>
          <p className="mt-3 text-sm text-slate-200" data-id="element-171">
            Everything you need to transform your dance fitness classes today.
          </p>
        </header>

        <article className="relative rounded-3xl border border-white/30 bg-navy-dark p-1 shadow-[0_18px_40px_rgba(0,0,0,.22)]" data-id="element-172">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-orange px-4 py-1 text-xs font-bold tracking-wide text-white" data-id="element-173">
            COMPLETE 7-IN-1 SYSTEM
          </span>
          <div className="rounded-[1.3rem] border border-white/10 p-6 text-center sm:p-10" data-id="element-174">
            <h3 className="font-display text-3xl font-bold text-white" data-id="element-175">
              Dance Fitness Instructor Pro™
            </h3>
            <p className="mt-2 text-sm text-slate-300" data-id="element-176">
              The complete ready-to-teach system for professional instructors.
            </p>

            <ul className="mx-auto my-6 max-w-md space-y-2 rounded-xl border border-white/15 bg-white/5 p-4 text-left" data-id="element-177">
              {included.map(item => <li key={item} className="flex gap-2 text-sm text-slate-100" data-id="element-178">
                  <CheckIcon className="mt-0.5 shrink-0 text-orange" size={16} data-id="element-179" />
                  {item}
                </li>)}
            </ul>

            <p className="text-lg text-slate-400 line-through" data-id="element-180">
              Regular Price: USD 97.00
            </p>
            <p className="mt-2 text-sm font-semibold text-orange" data-id="element-181">
              72% discount — Limited time offer
            </p>
            <p className="mt-1 text-xl text-white" data-id="element-182">
              LAUNCH PRICE:{' '}
              <strong className="ml-1 text-4xl text-orange sm:text-5xl" data-id="element-183">
                USD 27.00
              </strong>
            </p>

            <CheckoutButton className="mt-7 w-full border-white sm:w-auto" data-id="element-184">
              YES, I WANT THE COMPLETE 7-IN-1 SYSTEM
            </CheckoutButton>
            <p className="mt-4 text-xs text-slate-300" data-id="element-185">
              One-time payment. No subscriptions. No surprises. Immediate access
              delivered by email.
            </p>

            <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-200" data-id="element-186">
              {[[LockIcon, 'Secure payment'], [ZapIcon, 'Immediate access'], [ShieldIcon, '7-day guarantee']].map(([Icon, label]) => {
              const IconComponent = Icon as typeof LockIcon;
              return <span key={String(label)} className="flex items-center gap-1" data-id="element-187">
                    <IconComponent size={13} className="text-orange" data-id="element-188" />
                    {String(label)}
                  </span>;
            })}
            </div>

            <p className="mx-auto mt-5 flex max-w-md items-start gap-2 rounded-xl border border-white/15 bg-white/5 p-3 text-left text-[11px] leading-relaxed text-slate-300" data-id="element-189">
              <GlobeIcon size={14} className="mt-0.5 shrink-0 text-orange" data-id="element-190" />
              Pay in your local currency. The amount adapts automatically based
              on the country you are purchasing from.
            </p>
          </div>
        </article>
      </div>
    </section>;
}